import { useQueryClient } from '@tanstack/react-query';

import { PlanDetailsActionType } from '../../context/actions';
import { usePlanDetailsContext } from '../../context/context';

export const useCleanActivePlan = (): { run: Function } => {
  const { planDetailsDispatch } = usePlanDetailsContext();
  const queryClient = useQueryClient();

  return {
    run: async () => {
      planDetailsDispatch({
        type: PlanDetailsActionType.SET_ACTIVE_PLAN,
        payload: {
          activePlan: undefined,
        },
      });
      planDetailsDispatch({
        type: PlanDetailsActionType.SET_ACTIVE_PLAN_EDITING_GEO_FENCE,
        payload: {
          editingGeoFence: undefined,
        },
      });
      planDetailsDispatch({
        type: PlanDetailsActionType.SET_ACTIVE_PLAN_OPTIMIZATION_DATA,
        payload: {
          status: undefined,
          startedAt: undefined,
        },
      });
      planDetailsDispatch({
        type: PlanDetailsActionType.SET_ACTIVE_PLAN_SELECTED_STOPS,
        payload: {
          selectedStops: [],
        },
      });
      planDetailsDispatch({
        type: PlanDetailsActionType.SET_ACTIVE_PLAN_SELECTED_DRIVERS,
        payload: {
          selectedDrivers: [],
        },
      });

      // Clearing plan queries
      await queryClient.invalidateQueries([`planner_active_plan`]);
      await queryClient.invalidateQueries([`planner_active_plan_stops`]);
      await queryClient.invalidateQueries([`planner_active_plan_drivers`]);
      await queryClient.invalidateQueries([`planner_active_plan_geo_fences`]);
      await queryClient.invalidateQueries([`planner_active_plan_optimization`]);
    },
  };
};
